<!-- Pug Template -->
<template lang="pug">
div(
  v-if="display"
  :class="config.classes"
)
  template(
    v-for="placement in placements"
    v-if="display"
  )
    template(
      v-if="placement.body"
    )
      a.color-inherit.d-flex.flex-grow-1(
        @click="trackClick(placement)"
        :href="placement.redirect_url"
        :target="placement.target"
        v-html="placement.body"
      )
      
    template(
      v-if="!placement.body && placement.image_url"
    )
      a(
        @click="trackClick(placement)"
        :href="placement.redirect_url"
        :target="placement.target"
      )
        img(
          :alt="placement.alt_text"
          :src="placement.image_url"
          :width="placement.width"
          :height="placement.height"
        )
</template>

<!-- Script -->
<script>
const $ = jQuery;
import debounce from 'debounce';

// should this be unique?
const zone_instances = {};

const pid = (new Date()).getTime();

export default {
  name: 'AdPlacement',
  props:{
    config: {
      type: Object
    }
  },

  data(){
    const {viewports, zone_tag_json, endpoint} = this.config;
    if( zone_instances[zone_tag_json] === undefined ){
      zone_instances[zone_tag_json] = 0;
    }
    else {
      zone_instances[zone_tag_json]++;
    }
    return {
      viewports,
      place: +zone_instances[zone_tag_json],
      zone_tag_json,
      endpoint,
      cache: null,
      busy: false,
      windowWidth: 0,
      refreshTimeout: 0,
      placements: {}
    }
  },

  computed: {
    zoneData(){
      const parts = this.zone_tag_json.split(';');
      parts.shift();
      const data = {
        ua: navigator.userAgent.toString(),
        sw: screen.width,
        sh: screen.height,
        spr: window.devicePixelRatio,
        kw: window.abkw ? (Array.isArray(abkw) ? abkw.join(',') : abkw) : '',
        referrer: window.location.toString(),
        place: this.place,
        pid
      };
      parts.map( part => part.split('=', 2)).forEach(([key,val])=>data[key]=val);
      return data;
    },

    show(){
      return !this.viewports || this.viewports.includes(this.viewport);
    },

    viewport(){
      if(this.windowWidth < 500){
        return 'mobile';
      }
      if(this.windowWidth < 768 ){
        return 'tablet';
      }
      return 'desktop';
    },

    display(){
      return (this.show && this.placements.placement_1);
    }
  },

  watch: {
    show(v){
      this.maybeLoad();
      if( !v ){
        clearTimeout(this.refreshTimeout);
      }
    },

    display(v){
      if(v){
        // check to see if we are in a hidden excerpt box
        const $bookmark_carousel_item = $(this.$el).closest('.bookmarks-carousel__item');
        if( !$bookmark_carousel_item.length ){
          return;
        }
        $bookmark_carousel_item.css({display: ''});
        const $carousel = $bookmark_carousel_item.closest('.bookmarks-carousel');
        if( !$carousel.data('flickity') ){
          return;
        }
        $carousel.data('flickity').resize();
        // we should also watch for images loading in here...
        $(this.$el).find('img').on('load', e => $carousel.data('flickity').resize() );
      }
    },

    cache( ){
      // we need to look for a placement
      if( this.cache && this.cache.placements ){
        this.placements = this.cache.placements;
        // this is where we want to trigger our dataLayer event
        if( this.display ) {
          Object.values( this.placements ).forEach( placement => {
            this.trackImpression(placement);
          });
        }
        if( this.placements.placement_1 && this.placements.placement_1.refresh_url ){
          this.queueRefresh();
        }
      }
    }
  },

  mounted(){
    this.onResize = debounce(()=>this.updateWidth(), 50);
    $(window).on('resize.ad-placement orientationchange.ad-placement', this.onResize);
    this.updateWidth();
    this.maybeLoad();
    
  },

  destroyed(){
    $(window).off('resize.ad-placement orientationchange.ad-placement', this.onResize);
  },

  methods:{

    getEventParameters( placement ){
      const keys = [
        'campaign_name',
        'advertiser_id',
        'advertiser_name',
        'zone_name',
        'banner_name',
        'width',
        'height',
        'banner_id'
      ]
      const parameters = {};
      keys.forEach( key => {
        if( placement[key] ){
          parameters[key] = placement[key];
        }
      });
      return parameters;
    },

    trackClick(placement){
      if( !window.dataLayer ){
        return;
      }

      const payload = this.getEventParameters(placement);
      payload.event = 'ad_click';

      window.dataLayer.push(payload);

    },

    trackImpression(placement){
      if( !window.dataLayer ){
        return;
      }

      const payload = this.getEventParameters(placement);
      payload.event = 'ad_impression';

      window.dataLayer.push(payload);

    },

    updateWidth(){ 
      this.windowWidth = Number($(window).width());
    },

    parseUrl(url){
      const parts = url.split(';');
      parts.shift();
      const data = {
        ua: navigator.userAgent.toString(),
        sw: screen.width,
        sh: screen.height,
        spr: window.devicePixelRatio,
        kw: window.abkw ? (Array.isArray(abkw) ? abkw.join(',') : abkw) : '',
        referrer: window.location.toString()
      };
      parts.map( part => part.split('=', 2)).forEach(([key,val])=>data[key]=val);
      return data;
    },

    maybeLoad(){
      if( this.show && !this.cache && !this.busy ){
        this.load();
      }
      if( this.show && this.cache ){
        this.queueRefresh();
      }
    },

    queueRefresh(){
      if( !this.placements || !this.placements.placement_1 || !this.placements.placement_1.refresh_url ){
        return;
      }
      const placement = this.placements.placement_1;
      this.refreshTimeout = setTimeout(
        () => {
          // lets parse this...

          this.refresh(placement.refresh_url)
        },
        placement.refresh_time * 1000
      );
    },

    load(){
      this.busy = true;
      $.ajax({
        method: 'POST',
        url: this.config.endpoint,
        data: this.zoneData
      }).then( response => {
        this.cache = response;
        this.busy = false;
      }).fail( fail => {
        console.log( fail )
      });
    },

    refresh(url){
      this.zone_tag_json = url;
      this.load();
    }
  }
};
</script>